import React from 'react';
import CuadroDatos from '../../UI/CuadroDatos.js';
import UltimosCampeonesOrganizador from './UltimosCampeonesOrganizador.js';
import styles from './CuadroUltimosCampeonesSelec.module.css';

const CuadroUltimosCampeonesSelec = (props) => {
  const organizadores = props.organizadores;

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos titulo={'Ultimos campeones'} mostrar={true} isCargando={false} error={false}>
        <table className={`${styles.tablaCampeones}`}>
          <tbody>
            <tr className={`${styles.titulos}`}>
              <td className={`${styles.torneo}`}></td>
              <td className={`${styles.campeon}`}>Campeón</td>
              <td className={`${styles.subCampeon}`}>Subcampeón</td>
            </tr>
            {organizadores &&
              organizadores.map((organizador, index) => (
                <React.Fragment>
                  <tr key={'O' + index} className={`${styles.organizador}`}>
                    <td className={`${styles.organizador}`}>{organizador.nombre}</td>
                  </tr>
                  <UltimosCampeonesOrganizador
                    key={index}
                    organizador={organizador}
                    styles={styles}
                  />
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </CuadroDatos>
    </div>
  );
};

export default CuadroUltimosCampeonesSelec;
